// removed by extract-text-webpack-plugin
module.exports = {"heading":"G9ece53 Ge743c3 G42bbcd G60ed55","modal":"G820a6b","modalContainer":"G8f2f46","modalContent":"G237266 G699d38 Gcc633e Ge0b40c","msg":"G369fbe G50d90f Gd71c60"};